module.exports = __webpack_public_path__ + "img/bg_top.6e615be7.png";